import Reveal from "@/components/Reveal";
import { CHAPTERS } from "@/data/content";

export default function Chapters() {
  return (
    <section data-testid="chapters-section" className="bg-navy text-ivory relative grain-overlay overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-28">
        <Reveal>
          <p className="text-xs tracking-[0.24em] uppercase font-semibold text-gold">Our editorial promise</p>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl max-w-2xl leading-tight">
            Clear travel advice. Well-researched recommendations.
          </h2>
        </Reveal>
        <div className="mt-16 grid md:grid-cols-3 gap-px bg-ivory/15 rounded-2xl overflow-hidden">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.chapter} delay={i * 0.12} className="bg-navy">
              <div
                className="group h-full p-8 sm:p-10 transition-colors duration-500 hover:bg-[#16355a]"
                data-testid={`chapter-${c.chapter}`}
              >
                <p className="font-mono text-sm text-gold tracking-[0.2em]">{c.chapter}</p>
                <h3 className="mt-6 font-serif text-2xl sm:text-3xl leading-snug group-hover:text-gold transition-colors duration-500">
                  {c.title}
                </h3>
                <p className="mt-5 text-sm sm:text-base leading-relaxed text-ivory/65">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
